import { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, TYPE } from '@hub/common/Button/Button';
import { Checkbox } from '@hub/common/Checkbox/Checkbox';
import { Modal, ModalVariant } from '@hub/common/Modal/Modal';

type ComplianceModalProps = {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ComplianceModal = ({ visible, onClose, onConfirm }: ComplianceModalProps) => {
  const { t } = useTranslation('bearing-hub/bearingHub');
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (visible) {
      setAccepted(false);
    }
  }, [visible]);

  return (
    <Modal
      variant={ModalVariant.DEFAULT}
      visible={visible}
      onClose={onClose}
      headline={t('COMPLIANCE_DECLARATION.TITLE')}
    >
      <div data-testid="iglidur-z-compliance-modal" className="mt-10 ml-8 text-sm leading-6">
        <p className="font-bold mb-8">{t('COMPLIANCE_DECLARATION.IMPORTANT_PURCHASE_REQUIREMENTS')}</p>
        <p className="mb-4">
          <span className="font-bold">{t('COMPLIANCE_DECLARATION.INTRO_MATERIAL')}</span>{' '}
          {t('COMPLIANCE_DECLARATION.INTRO_TEXT')}
        </p>
        <ul className="list-disc pl-8 my-8 ml-8 leading-6 space-y-3">
          <li>
            <span className="font-bold">{t('COMPLIANCE_DECLARATION.DECLARATION_REQUIRED_LABEL')}</span>{' '}
            {t('COMPLIANCE_DECLARATION.DECLARATION_REQUIRED_TEXT')}
          </li>
          <li>
            <span className="font-bold">{t('COMPLIANCE_DECLARATION.MEDICAL_RESTRICTION_LABEL')}</span>{' '}
            {t('COMPLIANCE_DECLARATION.MEDICAL_RESTRICTION_TEXT_PREFIX')}{' '}
            <span className="font-bold">{t('COMPLIANCE_DECLARATION.MEDICAL_RESTRICTION_TEXT_HIGHLIGHT')}</span>{' '}
            {t('COMPLIANCE_DECLARATION.MEDICAL_RESTRICTION_TEXT_SUFFIX')}
          </li>
        </ul>
        <div className="text-base leading-[25px]">
          <Checkbox
            id="compliance-approval"
            key="compliance-approval"
            value={accepted}
            label={t('COMPLIANCE_DECLARATION.CHECKBOX_LABEL')}
            onChange={setAccepted}
          />
        </div>
        <div className="flex justify-end mt-10">
          <Button
            testId="iglidur-z-compliance-confirm"
            type={TYPE.PRIMARY}
            text={t('COMPLIANCE_DECLARATION.PROCEED_TO_CART')}
            disabled={!accepted}
            className="w-full md:w-[320px]"
            onClick={onConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};
